import React from 'react'
import {ITextElementModel} from '../../../Services/Topr.Umbraco/Models'
interface IProps {
  data: ITextElementModel
}

const TextElement: React.FC<IProps> = ({data}) => {
  return (
    <div className="section image-text markdown">
      <div className="columns">
        <div
          className="column"
          key="text"
          dangerouslySetInnerHTML={{__html: data.Text}}
        />
      </div>
    </div>
  )
}

export default TextElement
